module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/live.json
// module id = 327
// module chunks = 267078590975579